import React, {Fragment} from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatMasks, formatText} from 'presentation/utils';

import {StyledStack} from './styles';
import {HealthProviderDataSectionProps} from './types';
import {validateUrl} from 'presentation/utils/validateUrl';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function HealthProviderDataSection({provider}: HealthProviderDataSectionProps) {
	const isCPF = provider?.tipoPessoa === 1;
	const isValidWebsite = !!provider?.site && validateUrl(provider.site);

	return (
		<Fragment>
			<StyledStack>
				<DataInfo
					removeItemTextMargin
					iconName="assignment-lnd-filled"
					primaryText={guideDetails.nameSocialReason}
					secondaryText={provider.nmPrestador ? formatText(provider?.nmPrestador) : '-'}
					primaryTextColor="text.primary"
					secondaryTextColor="text.secondary"
					removePaddingBottom
				/>
				<DataInfo
					removeItemTextMargin
					iconName="assignment-lnd-filled"
					primaryText={guideDetails.fantasyName}
					secondaryText={provider.nmFantasia ? formatText(provider?.nmFantasia) : '-'}
					primaryTextColor="text.primary"
					secondaryTextColor="text.secondary"
					removePaddingBottom
				/>

				{isValidWebsite ? (
					<DataInfo
						removeItemTextMargin
						iconName="website-outline"
						primaryText={guideDetails.website}
						primaryTextColor="text.primary"
						secondaryTextColor="text.secondary"
						removePaddingBottom
						externalLinkUrl={provider.site}
					/>
				) : null}

				<DataInfo
					removeItemTextMargin
					iconName="text-box-outline"
					primaryText={guideDetails.crmDocument}
					secondaryText={provider?.crmcnes ? provider?.crmcnes : '-'}
					primaryTextColor="text.primary"
					secondaryTextColor="text.secondary"
					removePaddingBottom
				/>
				{isCPF ? null : (
					<DataInfo
						removeItemTextMargin
						iconName="assignment-outline"
						primaryText={guideDetails.juridicalName}
						secondaryText={
							provider?.cgccpf ? formatMasks('cnpj', String(provider?.cgccpf)) : '-'
						}
						primaryTextColor="text.primary"
						secondaryTextColor="text.secondary"
						removePaddingBottom
					/>
				)}
			</StyledStack>
		</Fragment>
	);
}
